import React from 'react';
import { Button } from '..';
import { Modal } from './../modal/modal';
import './dialog.scss';
import DOMPurify from 'dompurify';
export var Dialog = function (_a) {
    var show = _a.show, message = _a.message, submit = _a.submit, handleClose = _a.handleClose, _b = _a.closeButtonText, closeButtonText = _b === void 0 ? null : _b, _c = _a.modalType, modalType = _c === void 0 ? 'YesNo' : _c, _d = _a.modalTitle, modalTitle = _d === void 0 ? null : _d, yesButtonText = _a.yesButtonText, showYesButton = _a.showYesButton;
    // Sanitize the message to prevent XSS attacks
    var sanitizedMessage = DOMPurify.sanitize(message);
    return (React.createElement(Modal, { show: show, handleClose: handleClose, extendClass: "dialog-wrap" },
        modalType == 'Info' && modalTitle ? React.createElement("h3", { className: "modal-title" },
            " ",
            modalTitle) : '',
        React.createElement("p", { className: modalType === 'Info' ? 'justify-content' : '', dangerouslySetInnerHTML: { __html: sanitizedMessage } }),
        React.createElement("div", { className: "dialog-buttons" },
            React.createElement(Button, { type: "button", variant: modalType == 'Info' ? 'primary' : 'secondary', onClick: handleClose, childClasses: modalType == 'Info' ? 'fl-right' : '' }, closeButtonText ? closeButtonText : 'No'),
            showYesButton ? (React.createElement(Button, { type: "submit", variant: "primary", onClick: submit, childClasses: submit ? '' : 'hide' }, yesButtonText ? yesButtonText : 'Yes')) : (!showYesButton))));
};
